// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1KcW2","description":"PatientConsentPreview_description__BKI5m"};